import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';

const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class UserService {

    constructor(private http:HttpClient, private sharedapi:SharedService) { }

    getProfile()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-profile',{headers:webheader})
    }

    updateProfile(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.patch(apiUrl+'update-profile',data,{headers:webheader})
    }

    uploadProfilePicture(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-profile-pic',data,{headers:webheader})
    }

    changePassword(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.patch(apiUrl+'change-password',data,{headers:webheader})
    }

    getUserList(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-user-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    addUser(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-user',data,{headers:webheader})
    }

    getUserData(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'get-user-data',data,{headers:webheader})
    }

    updateUser(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-user-data',data,{headers:webheader})
    }

    deleteUser(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'delete-user',data,{headers:webheader})
    }

    updateUserStatus(data)
    {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-user-status',data,{headers:webheader})
    }

    updateUserMeetingRoomAccessStatus(data)
    {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-user-meeting-room-status',data,{headers:webheader})
    }

    updateUserLeadAssignStatus(data)
    {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-user-lead-assign-enable-status',data,{headers:webheader})
    }


    getUserByRole(role)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-user-by-role/'+role,{headers:webheader})
    }

    getUserByRolesAndCircle(requestData)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'get-user-by-roles-circle/', requestData,{headers:webheader})
    }

    deleteUserSession(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'delete-user-session',data,{headers:webheader})
    }

    getCityBdList(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-citybd-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    loadCityBdHistory(userid,pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-citybd-history/'+userid+'/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    getpresalesbds() {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-all-presales-users', {headers:webheader})
    }

    getTlsCms()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-tls-cms',{headers:webheader})
    }

    getUserHistory(user_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-user-history/'+user_id,{headers:webheader})
    }

    updateUserMarkAffiliateStatus(data)
    {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-user-mark-as-affiliate-status',data,{headers:webheader})
    }

    addAffiliateUser(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-affiliate-user',data,{headers:webheader})
    }

    getAffiliateUsers(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-affiliate-users-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    addAffiliateUserDescription(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-affiliate-user-description',data,{headers:webheader})
    }

    updateAffiliateUsers(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-affiliate-user-data',data,{headers:webheader})
    }

    getAffiliateUserData(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'get-affiliate-user-data',data,{headers:webheader})
    }

    getFullAffiliateUserHistory(user_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-affiliate-user-history/'+user_id,{headers:webheader})
    }

    //----------------All Active Affiliate Users----------------------//
    getActiveAffiliateUsers()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-all-affiliate-users',{headers:webheader})
    }

    //----------------Update User Display Number----------------------//
    updateUserDisplayNumber(data)
    {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-user-display-number',data,{headers:webheader})
    }
}
